import { render, staticRenderFns } from "./ServersOverview.vue?vue&type=template&id=0ad5cc14&scoped=true"
import script from "./ServersOverview.vue?vue&type=script&lang=js"
export * from "./ServersOverview.vue?vue&type=script&lang=js"
import style0 from "./ServersOverview.vue?vue&type=style&index=0&id=0ad5cc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5cc14",
  null
  
)

export default component.exports